import { useSelector } from "react-redux";
import { DisclaimerSelector } from "redux/selector";

function useInvestProperties(){
    const acceptedDisclaimer = useSelector(DisclaimerSelector.accepted)
    const investorPropertiesValid = useSelector(DisclaimerSelector.investorPropertiesValid)
    const valid = acceptedDisclaimer && investorPropertiesValid;

    return valid
}

export default useInvestProperties;